import cn from 'classnames'

import { Upload2Icon } from '@components/Icons'
import type { UploadBadgeFieldProps } from './interface'

export function UploadBadgeField({
  src,
  inputRef,
  isError,
  onChange,
  showUploadDialog,
}: UploadBadgeFieldProps) {
  return (
    <div className='relative cursor-pointer'>
      {src && (
        <div
          onClick={showUploadDialog}
          className='w-[159px] aspect-square rounded-[8px]'
        >
          <img src={src} className='w-full h-full rounded-[8px]' alt='cover' />
        </div>
      )}

      {!src && (
        <div
          className={cn(
            'bg-blue-2 w-[159px] h-[159px] rounded-[8px] flex flex-col items-center justify-center',
            {
              'border border-red': isError,
            }
          )}
          onClick={showUploadDialog}
        >
          <Upload2Icon className='text-secondary-100 w-[24px] h-[24px]' />
          <div className='text-secondary-100 font-medium font-mitr text-[14px] underline'>
            เพิ่ม Badge
          </div>
          <div className='text-secondary-100 text-[14px] font-light font-sarabun pt-[10px]'>
            300 X 320 px
          </div>
          <div className='text-secondary-100 text-[14px] font-light font-sarabun pt-[10px]'>
            PNG เท่านั้น
          </div>
        </div>
      )}

      <input
        ref={inputRef}
        className='hidden'
        type='file'
        accept='image/*'
        onChange={onChange}
      />
    </div>
  )
}
